import { z } from "zod";

export const createJobSchema = z.object({
  title: z.string().min(1, "Title is required"),
  description: z.string().min(1, "Description is required"),
  requirements: z.string().min(1, "Requirements are required"),

  industryIds: z
    .array(z.string())
    .min(1, "At least one industry is required"),

  countryIds: z
    .array(z.string())
    .min(1, "At least one country is required"),

  expirationDate: z.string().min(1, "Expiration date is required"),
  status: z.string().min(1, "Status is required"),
});

export type CreateJobFormValues = z.infer<
  typeof createJobSchema
>;